import { showElements, hideElements } from 'client/javascript/util/dom_utils';

export default class Wizard {
  constructor(container) {
    this.step1 = container.querySelector('#wizard-step-1');
    this.step2 = container.querySelector('#wizard-step-2');
    this.stepIndicator = container.querySelector('#wizard-step-indicator');
    this.backButton = container.querySelector('#wizard-back-btn');

    this.currentStepNum = container.querySelector('#wizard-current-step-num');
    this.backButton.addEventListener('click', this.goToStep1.bind(this));

    const stepNum = container.querySelector('#wizard-total-num-steps');
    stepNum.innerHTML = 2;
  }

  goToStep1() {
    this.currentStepNum.innerHTML = 1;

    hideElements(this.backButton, this.stepIndicator, this.step2);
    showElements(this.step1);
  }

  goToStep2() {
    this.currentStepNum.innerHTML = 2;

    hideElements(this.step1);
    showElements(this.backButton, this.stepIndicator, this.step2);
  }
}
